const SampleSearches = [
  "How has music evolved over time? 🎹",
  "What happened before the Big Bang? 💥",
  "How will artificial intelligence impact society? 🤖",
  "Famous explorers",
  "What is the meaning of life? 🤔",
  "How to make rockets go brrrrr",
  "🖌️🎨🧑‍🎨",
  "💃🕺🎶",
  "🤖🦾🦿",
  "🧬🧫🧪",
  "🪐🌎🌌",
  "How can we solve climate change?",
  "Science and technology in ancient civilizations",
  "How can we become a multiplanetary species?",
  "Are we alone in the universe?",
  "What makes water wet",
  "Basics of weight lifting",
  "Synthetic biology",
  "CS 3130",
  "ENWR 1510",
  "Interplay between science and religion",
  "Why does capitalism work?",
  "DS 3005",
  "RUTR 3360",
  "PHIL 1330",
  "What are the underlying principles of democracy",
  "Literature from across the world",
  "ASTR 3450",
  "CS 4710",
  "JPTR 3400",
  "How has education changed over time?",
  "The history of science",
  "Art of the renaissance era",
  "The Roman Empire",
  "GETR 3790"
];

export default SampleSearches;